import { STAFF_ROUTE_PERMISSIONS } from "@/components/navigation/staffMenu";
/**
 * Вкладки карточки компании (UC1113) — единый источник для `AppRouter` (маршруты + ProtectedRoute)
 * и `CompanyPage` (Tabs). «Взаиморасчёты» — только ADMINISTRATOR (D14).
 */
export const COMPANY_TABS = [
    { key: "settings", label: "Реквизиты и настройки", testId: "corp-company-tab-settings", permission: STAFF_ROUTE_PERMISSIONS.companies },
    { key: "tariffs", label: "Тарифы", testId: "corp-company-tab-tariffs", permission: STAFF_ROUTE_PERMISSIONS.companies },
    { key: "employees", label: "Сотрудники", testId: "corp-company-tab-employees", permission: STAFF_ROUTE_PERMISSIONS.companies },
    { key: "admins", label: "Администраторы", testId: "corp-company-tab-admins", permission: STAFF_ROUTE_PERMISSIONS.companies },
    { key: "settlements", label: "Взаиморасчёты", testId: "corp-company-tab-settlements", permission: STAFF_ROUTE_PERMISSIONS.companySettlements },
    { key: "report", label: "Отчёт", testId: "corp-company-tab-report", permission: STAFF_ROUTE_PERMISSIONS.companies },
];
export const DEFAULT_COMPANY_TAB = "settings";
export const companyTabPath = (companyId, tab = DEFAULT_COMPANY_TAB) => `/companies/${companyId}/${tab}`;
